module.exports = __webpack_public_path__ + "img/hero-crew.d5b2bf7c.png";